import React, { memo } from "react";
import Backdrop from "components/backdrop/Backdrop";
import styles from "./PlayerModal.module.scss";
import classNames from "classnames";
import isEqual from "react-fast-compare";

interface Props {
  aparatLink: string;
  title?: string;
  onClose: (event?: React.MouseEvent) => void;
}

const PlayerModal: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const src = `https://www.aparat.com/video/video/embed/videohash/${props.aparatLink
    .split("/")
    .pop()}/vt/frame`;
  return (
    <Backdrop
      className={classNames(styles.Container)}
      isOpen={true}
      onClick={props.onClose}
    >
      <iframe title={props.title ?? "video"} src={src} allowFullScreen></iframe>
    </Backdrop>
  );
};

export default memo(PlayerModal, isEqual);
